// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import ThemeColorPresets from './components/ThemeColorPresets';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import Notifications from './components/Notifications';
import IdleSessionGuard from './components/IdleSessionGuard';
import useAuth from './hooks/useAuth';

// ----------------------------------------------------------------------

export default function App() {
  const { isAuthenticated } = useAuth();
  return (
    <ThemeProvider>
      <ThemeColorPresets>
        <MotionLazyContainer>
          <ProgressBarStyle />
          <ScrollToTop />
          <Router />
          {/* 30-minute idle sign-out (user-management enforces it too) */}
          {isAuthenticated && <IdleSessionGuard />}
          <Notifications />
        </MotionLazyContainer>
      </ThemeColorPresets>
    </ThemeProvider>
  );
}
